import { InjectionToken } from '@angular/core';
import {
  ISystemParam,
  ISystemParamsGridItem,
  ISystemParamUpdateParams,
} from '@core/interfaces/system-params';
import { IGridRequestBody, IGridResponseBody } from 'mt-ui-lib/interfaces';
import { Observable } from 'rxjs';

export interface SystemParamsDataSource {
  readonly source: string;
  getGrid(
    body: IGridRequestBody,
  ): Observable<IGridResponseBody<ISystemParamsGridItem>>;
  getInfo(id: string): Observable<ISystemParam>;
  updateParam(
    id: string,
    params: ISystemParamUpdateParams,
  ): Observable<unknown>;
}

export const SYSTEM_PARAMS_DATA_SOURCE =
  new InjectionToken<SystemParamsDataSource>('SYSTEM_PARAMS_DATA_SOURCE');
